"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
require("../list");
//@ts-ignore
require("../theme.ts");
var TransferList = /** @class */ (function (_super) {
    __extends(TransferList, _super);
    function TransferList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.leftToRight = function () {
            _this.props.right = __spreadArrays(_this.props.right, _this.props.left);
            _this.props.left.length = 0;
            _this._checkLeftDisabled();
            _this._checkRightDisabled();
            _this.update(true);
            _this.fire('change', { left: _this.props.left, right: _this.props.right });
        };
        _this.rightToLeft = function () {
            _this.props.left = __spreadArrays(_this.props.left, _this.props.right);
            _this.props.right.length = 0;
            _this._checkLeftDisabled();
            _this._checkRightDisabled();
            _this.update(true);
            _this.fire('change', { left: _this.props.left, right: _this.props.right });
        };
        _this.sltLeftToRight = function () {
            //@ts-ignore
            var temp = _this.props.left.filter(function (item) { return !item.checked; });
            _this.props.left.forEach(function (item) {
                //@ts-ignore
                item.checked && _this.props.right.push(item);
                //@ts-ignore
                item.checked = false;
            });
            _this.props.left = temp;
            _this._checkLeftDisabled();
            _this._checkRightDisabled();
            _this.update(true);
            _this.fire('change', { left: _this.props.left, right: _this.props.right });
        };
        _this.sltRightToRight = function () {
            //@ts-ignore
            var temp = _this.props.right.filter(function (item) { return !item.checked; });
            _this.props.right.forEach(function (item) {
                //@ts-ignore
                item.checked && _this.props.left.push(item);
                //@ts-ignore
                item.checked = false;
            });
            _this.props.right = temp;
            _this._checkLeftDisabled();
            _this._checkRightDisabled();
            _this.update(true);
            _this.fire('change', { left: _this.props.left, right: _this.props.right });
        };
        _this._rightBtnDiabled = true;
        _this._leftBtnDiabled = true;
        _this._rightAllBtnDiabled = true;
        _this._leftAllBtnDiabled = true;
        _this.onLeftItemClick = function (evt) {
            evt.detail.item.checked = !evt.detail.item.checked;
            _this._checkLeftDisabled();
            _this.update(true);
        };
        _this.onRightItemClick = function (evt) {
            evt.detail.item.checked = !evt.detail.item.checked;
            _this._checkRightDisabled();
            _this.update(true);
        };
        return _this;
    }
    TransferList.prototype.install = function () {
        this._checkLeftDisabled();
        this._checkRightDisabled();
    };
    TransferList.prototype._checkLeftDisabled = function () {
        var len = this.props.left.length;
        if (len === 0) {
            this._rightBtnDiabled = true;
            this._rightAllBtnDiabled = true;
            return;
        }
        else {
            this._rightAllBtnDiabled = false;
        }
        for (var i = 0; i < len; i++) {
            //@ts-ignore
            if (this.props.left[i].checked) {
                this._rightBtnDiabled = false;
                return;
            }
        }
        this._rightBtnDiabled = true;
    };
    TransferList.prototype._checkRightDisabled = function () {
        var len = this.props.right.length;
        if (len === 0) {
            this._leftBtnDiabled = true;
            this._leftAllBtnDiabled = true;
            return;
        }
        else {
            this._leftAllBtnDiabled = false;
        }
        for (var i = 0; i < len; i++) {
            //@ts-ignore
            if (this.props.right[i].checked) {
                this._leftBtnDiabled = false;
                return;
            }
        }
        this._leftBtnDiabled = true;
    };
    TransferList.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'm-m-transfer-list')),
            omi_1.h("m-list", __assign({ checkbox: true, checkboxLeft: true, css: "ul{\n        border: 1px solid rgba(0,0,0,.1);\n        min-width:190px;\n        border-radius: " + (document.body.style.getPropertyValue('--mdc-shape-medium-component-radius') || '4px') + ";\n      }" }, (props.width ? { wdith: props.width } : {}), { height: props.height || 195, items: props.left, onItemClick: this.onLeftItemClick })),
            omi_1.h("div", { class: 'btns' },
                omi_1.h("button", { disabled: this._rightAllBtnDiabled, onClick: this.leftToRight }, "\u226B"),
                omi_1.h("button", { disabled: this._rightBtnDiabled, onClick: this.sltLeftToRight }, ">"),
                omi_1.h("button", { disabled: this._leftBtnDiabled, onClick: this.sltRightToRight }, '<'),
                omi_1.h("button", { disabled: this._leftAllBtnDiabled, onClick: this.rightToLeft }, "\u226A")),
            omi_1.h("m-list", __assign({ checkbox: true, checkboxLeft: true, css: "ul{\n        border: 1px solid rgba(0,0,0,.1);\n        min-width:190px;\n        border-radius: " + (document.body.style.getPropertyValue('--mdc-shape-medium-component-radius') || '4px') + ";\n      }" }, (props.width ? { wdith: props.width } : {}), { height: props.height || 195, items: props.right, onItemClick: this.onRightItemClick }))));
    };
    TransferList.css = css;
    TransferList.propTypes = {
        left: Array,
        right: Array
    };
    TransferList = __decorate([
        omi_1.tag('m-transfer-list')
    ], TransferList);
    return TransferList;
}(omi_1.WeElement));
exports.default = TransferList;
